{
	"nav": {
		"features": "Features",
		"pricing": "Pricing",
		"about": "About",
		"careers": "Careers",
		"contact": "Contact",
		"sign_in": "Log in",
		"sign_up_free": "Sign up free",
		"open_menu": "Open menu",
		"close_menu": "Close menu"
	},
	"footer": {
		"product": "Product",
		"company": "Company",
		"legal": "Legal",
		"features": "Features",
		"pricing": "Pricing",
		"demo": "Live demo",
		"about": "About",
		"careers": "Careers",
		"contact": "Contact",
		"privacy": "Privacy",
		"terms": "Terms",
		"legal_notices": "Legal notices",
		"tagline": "Your community. Your brand. Powered by AI.",
		"rights": "© {{year}} UpSquad, Inc. All rights reserved.",
		"language": "Language"
	},
	"cta": {
		"book_demo": "Book a demo",
		"learn_more": "Learn more",
		"talk_to_sales": "Talk to sales",
		"contact_us": "Contact us",
		"sign_up_free": "Sign up free"
	},
	"not_found": {
		"meta_title": "Page not found",
		"eyebrow": "Error 404",
		"title": "This page doesn't exist.",
		"body": "The link may be broken or the page may have moved. Head back to the homepage to keep exploring UpSquad.",
		"back_home": "Back to home"
	},
	"toast": {
		"contact_success": "Message sent — we'll get back to you shortly.",
		"contact_error": "Something went wrong. Please try again.",
		"contact_rate_limit": "Too many requests. Please try again in a minute."
	}
}
